import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const SIZE_MAP = {
  small: 24,
  medium: 32,
  large: 40,
};

/**
 * Consistent loading indicator.
 * @param {'inline'|'centered'|'overlay'} layout
 */
export default function LoadingState({
  message = 'Loading…',
  layout = 'centered',
  size = 'medium',
  showMessage = true,
  sx,
}) {
  const spinnerSize = SIZE_MAP[size] || SIZE_MAP.medium;

  const content = (
    <>
      <CircularProgress size={spinnerSize} sx={{ color: 'var(--color-primary-main)' }} />
      {showMessage && message && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1.5 }}
        >
          {message}
        </Typography>
      )}
    </>
  );

  if (layout === 'inline') {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.5,
          ...sx,
        }}
      >
        <CircularProgress size={spinnerSize} sx={{ color: 'var(--color-primary-main)' }} />
        {showMessage && message && (
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        )}
      </Box>
    );
  }

  if (layout === 'overlay') {
    return (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.72)',
          zIndex: 2,
          ...sx,
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        ...sx,
      }}
    >
      {content}
    </Box>
  );
}
